import isEqual from 'lodash/isEqual'
import {z} from 'zod'

import {FormValidationInput} from '../../../types'
import {TruckForm} from '../../trucks/types'
import {shouldPreserveSpacingOrFlowRate} from '../shouldPreserveSpacingOrFlowRate'
import {LoadSpacingConfiguration, LoadSpacingForm} from '../types'

import {validateSpacingOrFlowRate} from './validateSpacingOrFlowRate'
import {validateTimeOnJobSite} from './validateTimeOnJobSite'

export const validateLoadSpacing = (
  data: LoadSpacingForm & TruckForm,
  ctx: z.RefinementCtx,
  {
    configuration: {loadSpacing: loadSpacingConfiguration},
    defaultValues
  }: FormValidationInput<LoadSpacingConfiguration>
) => {
  if (!loadSpacingConfiguration.isEnabled) {
    return
  }

  const {scenarios, flowRate, loadSpace, timeOnJobSite} = loadSpacingConfiguration
  const scenario = scenarios[data.isMultipleTruck ? 'multipleTrucks' : 'singleTruck']

  validateTimeOnJobSite(data, scenario, timeOnJobSite!, ctx)
  if (
    shouldPreserveSpacingOrFlowRate(
      loadSpacingConfiguration,
      defaultValues?.spacingOrFlowRate?.type
    ) &&
    isEqual(data.spacingOrFlowRate, defaultValues?.spacingOrFlowRate)
  ) {
    return
  }
  validateSpacingOrFlowRate(data, scenario, loadSpace!, flowRate!, ctx)
}
